{
  "nameTemplate": "Modèle {{name}}",
  "editor": "Éditeur(trice)",
  "frequency": "Fréquence",
  "frequencyTitle": "Fréquence de génération du rapport",
  "oneTimeReportTitle": "Générer un rapport unique",
  "rules": "Règles",
  "settings": "Settings",
  "publish": "publier",
  "frequencies": {
    "weekly": "Hebdomadaire",
    "onceAWeek": "Une fois par semaine",
    "dayOfNextWeek": "jour de la semaine prochaine (1-7, du lundi au dimanche)",
    "monthly": "Mensuel",
    "onceAMonth": "Une fois par mois",
    "dayOfNextMonth": "jour du mois prochain (1-28)",
    "quarterly": "Trimestriel",
    "onceAQuarter": "Une fois par trimestre",
    "dayOfNextQuarter": "jour du premier mois dans le prochain trimestre (1-28)",
    "yearly": "Annuel",
    "onceAYear": "Une fois par an",
    "dayOfNextYear": "jour de janvier, l'année prochaine (1-28)",
    "outOfBounds": "Hors limite",
    "one_time": "Unique",
    "oneTimeRange": "Une période unique",
    "oneTimeStart": "Date de début",
    "oneTimeEnd": "Date de fin"
  },
  "comparisons": {
    "EQUALS": "Est égal à",
    "NOT_EQUALS": "NON_ÉGAL",
    "INCLUDES": "INCLUS",
    "NOT_INCLUDES": "NON_INCLUS",
    "IN": "DANS",
    "NOT_IN": "PAS_DANS",
    "GREATER_THAN": "SUPÉRIEUR_À",
    "LESS_THAN": "INFÉRIEUR_À",
    "GREATER_THAN_AGO": "SUPÉRIEUR_À_PLUS_TÔT",
    "LESS_THAN_AGO": "INFÉRIEUR_À_PLUS_TÔT"
  },
  "addRule": "Ajouter une règle",
  "edit": "Modifier",
  "variablesAvailableForThisTemplate": "Variables disponibles pour ce modèle",
  "savedSuccessfully": "Modèle bien enregistré",
  "editModal": {
    "title": "Modifier le modèle de rapports clients",
    "type": "Type",
    "description": "Description",
    "name": "Nom"
  },
  "newModal": {
    "title": "Nouveau modèle de rapports clients",
    "objectType": "Association",
    "type": "Type",
    "name": "Nom",
    "reportType": "Type de rapport",
    "frequency": "Fréquence",
    "reportTypes": {
      "HTML": "HTML",
      "PAGE_CONFIGURATION": "Configuration de la page"
    }
  },
  "updateState": {
    "activate": "Activer",
    "deactivate": "Désactiver",
    "archive": "Archiver",
    "review": "Examiner"
  },
  "settingsTab": {
    "coverPage": {
      "settingsTitle": "Détails de la page de couverture",
      "title": "Titre",
      "subtitle": "Sous-titre",
      "disableBrandColor": "Désactiver la couleur de la marque",
      "enableCompanyLogo": "Activer le logo de l'entreprise",
      "enablePreparedBy": "Activer l'indication « Préparé par »",
      "preparedBy": "Préparé par",
      "enabled": "Activer la page de couverture"
    },
    "footer": {
      "settingsTitle": "Détails du pied de page",
      "text": "Texte",
      "enableOnCoverPage": "Activer sur la page de couverture",
      "enableAlternateCoverPageText": "Activer le texte alternatif pour la page de couverture",
      "alternateCoverPageText": "Texte alternatif de la page de couverture",
      "enabled": "Activer le pied de page"
    },
    "header": {
      "settingsTitle": "Détails de l'en-tête",
      "text": "Texte",
      "enableOnCoverPage": "Activer sur la page de couverture",
      "enableAlternateCoverPageText": "Activer le texte alternatif pour la page de couverture",
      "alternateCoverPageText": "Texte alternatif de la page de couverture",
      "enabled": "Activer l'en-tête"
    },
    "tableOfContents": {
      "settingsTitle": "Détails de la table des matières",
      "title": "Titre",
      "enabled": "Activer la table des matières"
    },
    "general": {
      "settingsTitle": "Détails généraux",
      "brandColor": "Couleur de la marque"
    }
  },
  "clientReport": "Rapport client"
}
